import { extend, localize, setInteractionMode } from 'vee-validate';
import it from 'vee-validate/dist/locale/it.json';
import { confirmed, email, integer, max_value as maxValue, min_value as minValue, numeric, regex, required } from 'vee-validate/dist/rules';

setInteractionMode('passive');

extend('required', required);
extend('regex', regex);
extend('email', email);
extend('confirmed', confirmed);
extend('integer', integer);
extend('min_value', minValue);
extend('max_value', maxValue);
extend('numeric', numeric);

localize('it', it);
